import Space from "Components/Space";
import PageLayout from "Layouts/PageLayout";
import {useNavigate, useParams} from "react-router-dom";
import CalculatorIcon from "../../../Assets/SVG/CalculatorIcon";
import {useTranslation} from "react-i18next";
import ShopifyOrderIntegrationForm from "../../../Features/Settlements/ShopifyOrderIntegrationForm";
import {useMigrateShopifyIntegration, useShopifyOrderIntegration,} from "../../../Apis/ShopifyOrderIntegrationApi";
import Button from "../../../Components/Button";
import useToasts from "../../../Hooks/UseToasts";

const Edit = () => {

    const { id } = useParams();
    
    const { t } = useTranslation();

    const { showSuccessToast } = useToasts();

    const { data: shopifyOrderIntegration, isLoading } = useShopifyOrderIntegration(parseInt(id!));

    const { mutateAsync, isLoading: isMigrating } = useMigrateShopifyIntegration();

    const migrate = async () => {
        await mutateAsync(shopifyOrderIntegration!);

        showSuccessToast(t('shopifyOrderIntegrationMigratedSuccessfully'))
    }

    const navigate = useNavigate();

    return (
        <PageLayout title={t('shopifyOrderIntegration')} icon={<CalculatorIcon />} includeBox loading={isLoading} header={(
            <Button type={"secondary"} loading={isMigrating} text={t('migrate')} onClick={migrate} />
        )}>
            <Space size={"large"} direction={"vertical"}>
                <ShopifyOrderIntegrationForm entity={shopifyOrderIntegration!} onSubmit={_ => navigate(-1)} />
            </Space>
        </PageLayout>
    )

}

export default Edit;